import React, { useState } from 'react'
import {useTranslation} from "react-i18next";

const Switch  = ({onChange}) => {
  const [isChecked, setIsChecked] = useState(false)
  const { t } = useTranslation();

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked)
    onChange(isChecked ? 1 : 2)
  }

  return (
    <>
      <label className='themeSwitcherTwo shadow-card relative inline-flex cursor-pointer select-none items-center justify-center rounded-md bg-gray-200 py-2 px-2 '>
        <input
          type='checkbox'
          className='sr-only'
          checked={isChecked}
          onChange={handleCheckboxChange}
        />
        <span
          className={`flex items-center space-x-[6px] rounded py-2 px-[8px] text-xs font-semibold ${
            !isChecked ? 'text-black bg-white' : 'text-body-color'
          }`}
        >
          {t("oneWay")}
        </span>
        <span
          className={`flex items-center space-x-[6px] rounded py-2 px-[8px] text-xs font-semibold ${
            isChecked ? 'text-black bg-white' : 'text-body-color'
          }`}
        >
           {t("twoWay")}
        </span>
      </label>
    </>
  )
}

export default Switch
